/*
 * @Author: wp530511
 * @Date: 2024-08-16 14:06:11
 * @LastEditors: wp530511
 * @LastEditTime: 2024-08-16 14:16:33
 * @FilePath: \pc-seo-v2\plugins\repeat.js
 * @Description: 表单防止重复提交指令
 *
 */
import Vue from 'vue'
const repeat = Vue.directive('repeat', {
	inserted: function (el, binding) {
		el.addEventListener('click', () => {
			if (!el.disabled) {
				el.disabled = true
				setTimeout(() => {
					el.disabled = false
				}, binding.value || 2000)
			}
		})
	}
})
export default repeat
